export default __webpack_public_path__ + "static/media/pic92.a25444d2.jpg";